import type { TypedUseSelectorHook } from "react-redux";
import {
  useDispatch as useUntypedDispatch,
  useSelector as useUntypedSelector,
} from "react-redux";
import type { RootState, AppDispatch } from "../services/store";

export const useDispatch = () => useUntypedDispatch<AppDispatch>();
export const useSelector: TypedUseSelectorHook<RootState> = useUntypedSelector;
